import { Component, inject } from '@angular/core';
import { StandTransformationHistoryDetailService } from '../proxy/geographic/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandTransformationHistoryDetailCreateDto,
  StandTransformationHistoryDetailDto,
  StandTransformationHistoryDetailExcelDownloadDto,
  StandTransformationHistoryDetailUpdateDto,
} from '../proxy/geographic/dtos/stand-transformation-history-detail';
import { STANDTRANSFORMATIONHISTORYDETAIL_CONFIG, STANDTRANSFORMATIONHISTORYDETAIL_FIELDS } from './stand-transformation-history-detail.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stand-transformation-history-detail',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandTransformationHistoryDetailService, ConfirmationService],
  templateUrl: './stand-transformation-history-detail.html',
  styleUrl: './stand-transformation-history-detail.scss',
})
export class StandTransformationHistoryDetail extends BaseCrudComponent<
  StandTransformationHistoryDetailDto,
  StandTransformationHistoryDetailCreateDto,
  StandTransformationHistoryDetailUpdateDto,
  StandTransformationHistoryDetailExcelDownloadDto
> {
  service = inject(StandTransformationHistoryDetailService);
  config = STANDTRANSFORMATIONHISTORYDETAIL_CONFIG;
  fields = STANDTRANSFORMATIONHISTORYDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandTransformationHistoryDetailDto): StandTransformationHistoryDetailUpdateDto {
    return {
      area: data.area,
      areaPercentage: data.areaPercentage,
      standTransformationHistoryId: data.standTransformationHistoryId,
      rotationId: data.rotationId,
      isFinal: data.isFinal,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandTransformationHistoryDetail';
  }
}
